/* =================================================================
   br-motion-reveal — shared blur-to-clear reveal utility.

   Re-implements the &Fold donor's IX2 reveals (action list "a" /
   animate="text" / a/title — opacity 0 + blur(20px), revealed once
   when scrolled into view) in vanilla JS, consolidated from the three
   section-local copies (br-about-introduction, br-cta-block,
   br-video-story). The transition itself (duration, easing, delay)
   lives in each section's own CSS — the donor's per-section values
   differ (1000ms outQuart vs 1500ms outExpo + 100ms delay), so this
   utility owns only the OBSERVER mechanics: gating, arming, one-shot
   reveal.

   USAGE CONTRACT

     window.brMotion.reveal({
       scope: '.br-section',   // selector; each match is wired
                               // independently. Omit to use `document`
                               // (item-scoped wiring, e.g. video-story).
       target: '[data-…-reveal]', // selector resolved within each scope;
                               // every match is armed and observed.
       observe: 'target',      // 'target' (default) or 'scope' — which
                               // element the observer watches
                               // (about-introduction observes the section).
       rootMargin: '0px 0px -20% 0px', // donor scrollOffset, per section
       threshold: 0,           // observer threshold (default 0)
       arm: function (scope, target) { … },    // apply the hidden state
       reveal: function (scope, target) { … }, // apply the revealed state
     })

   GUARANTEES (same as the section-local copies)

   - Progressive: the hidden "armed" state is applied ONLY by arm(),
     which this utility calls only when it can also reveal — so without
     JS the content is simply visible. No FOUC, no JS-dependent hiding.
   - prefers-reduced-motion (checked once at init) or no
     IntersectionObserver: nothing is armed; the content stays visible.
     (The section-local "reveal immediately when gated" paths were
     visual no-ops — the armed styles they unset were never applied.)
   - One-shot: the observer disconnects after the first reveal, like
     the donor's non-looping event.
   - Idempotent: re-executing this file is a no-op (global guard);
     re-arming the same target element is skipped (theme-editor section
     re-renders re-execute section scripts).

   No globals beyond window.brMotion.
   ================================================================= */
(function () {
  window.brMotion = window.brMotion || {};
  if (window.brMotion.reveal) return; /* already loaded by another section */

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  window.brMotion.reveal = function (config) {
    /* Never armed => always visible. This is the whole reduced-motion
       and no-IntersectionObserver fallback. */
    if (REDUCED.matches || !('IntersectionObserver' in window)) return;

    var scopes = config.scope ? document.querySelectorAll(config.scope) : [document];
    scopes.forEach(function (scope) {
      var targets = scope.querySelectorAll(config.target);
      targets.forEach(function (target) {
        if (target.__brMotionReveal) return; /* theme-editor re-execution */
        target.__brMotionReveal = true;

        config.arm(scope, target);

        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              config.reveal(scope, target);
              observer.disconnect();
            });
          },
          {
            rootMargin: config.rootMargin || '0px',
            threshold: config.threshold != null ? config.threshold : 0,
          }
        );
        observer.observe(config.observe === 'scope' ? scope : target);
      });
    });
  };
})();
